/*@ngInject*/
const FormStructureUtil = function ($q, $timeout, fieldType, formViewerUtil, xmlUtil, formComponentUtil, formatUtil, uuidUtil, rowRepeaterUtil) {

    this.buildFormStructure = function (rootFormId, sourceForm, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, rowRepeaterMap, fieldMap, topLevelSectionList, printPreview, currencyCode, isConfigurableForm) {
        let defer = $q.defer(),
            formRoot = {
                uiFormTemplate: sourceForm,
                formModel: _.find(formSummaryList, {formTemplateId: sourceForm.formTemplate.id}),
                hasWriteAccess: hasWriteAccess,
                sectionList: null,
                hasResponsiveLayout: sourceForm.formTemplate.flags === 'wrap',
                isConfigurableForm: isConfigurableForm
            },
            formConfig,
            isSupplemental,
            previousFieldKey,
            precedingFieldInfo;

        isSupplemental = (sourceForm.precedingFieldFormId && sourceForm.precedingFieldFormId > 0);

        formRoot.formModel = _.extend(formRoot.formModel, {printPreview: printPreview});

        if (isSupplemental) {
            precedingFieldInfo = formViewerUtil.findPrecedingFieldRowForSupplementalForm(formRoot.uiFormTemplate.precedingFieldVariableName, formRoot.uiFormTemplate.precedingFieldFormTemplateUniqueName, topLevelSectionList);

            if (precedingFieldInfo) {
                previousFieldKey = formViewerUtil.findLastFieldInPreviousRowKey(precedingFieldInfo.precedingFieldRow);
            }
        }

        formRoot.formModel.hasWriteAccess = hasWriteAccess;

        function buildSections(sections) {
            let sectionList = [],
                formHeight = 0,
                sectionConfig;

            _.each(sections, function (section) {

                sectionConfig = buildRows(section.rows);

                sectionList.push({
                    rootFormId: rootFormId,
                    sectionStructureId: rootFormId + '-' + section.id,
                    sectionTemplate: section,
                    rowList: sectionConfig.rowList,
                    sectionHeight: sectionConfig.sectionHeight,
                    parentUiFormTemplate: formRoot.uiFormTemplate
                });

                formHeight += sectionConfig.sectionHeight;
            });

            return {
                formHeight: formHeight,
                sectionList: sectionList
            };
        }

        function getRowRepeaterFieldStructure(row) {
            const fieldStructure = _.find(row.fields, function (fieldStructure) {
                return fieldStructure.fieldTemplate.type === fieldType.ROWREPEATER;
            });
            return fieldStructure;
        }

        function buildRows(sectionRows) {

            let rowList = [],
                totalSectionHeight = 0,
                rowRepeater;

            function getRowRepeaterField(rowList) {
                let result = null,
                    fieldStructureList = _.last(rowList).fieldStructureList;

                _.find(fieldStructureList, function (fieldStructure) {
                    let fieldStructureType = _.get(fieldStructure, 'uiField.fieldTemplate.type'),
                        isRowRepeater = fieldStructureType === fieldType.ROWREPEATER;

                    if (isRowRepeater) {
                        result = fieldStructure;
                        return false;
                    }
                });

                return result;
            }

            function getPageSize(row) {
                let options = xmlUtil.parseString(row.repeaterField.options);
                if (options.rowsPerPage) {
                    return parseInt(options.rowsPerPage);
                } else {
                    return 0;
                }
            }

            _.each(sectionRows, function (row) {
                let fieldConfig,
                    rowRepeaterConfig,
                    titlebarHeight = 70,
                    pagingHeight = 25,
                    rowHeight,
                    rowListHeight;

                if (row.rowRepeatable) {

                    if (formRoot.isConfigurableForm) {
                        rowRepeaterConfig = buildStaticRepeatingRowList(row);
                    }
                    else {
                        rowRepeaterConfig = buildRepeatingRowList(row);
                    }

                    const rowFieldStructure = getRowRepeaterFieldStructure(row);

                    rowRepeater = {
                        rootFormId: rootFormId,
                        rowStructureId: rootFormId + '-' + row.id,
                        parentFormStructure: formRoot,
                        parentUiFormTemplate: formRoot.uiFormTemplate,
                        parentForm: formRoot.formModel,
                        rowRepeaterId: row.id,
                        repeating: true,
                        repeaterFieldStructure: getRowRepeaterField(rowRepeaterConfig.repeatingRowList),
                        rowRepeaterName: rowRepeaterUtil.getRowRepeaterName(rowFieldStructure),
                        rowTemplate: row,
                        rowList: rowRepeaterConfig.repeatingRowList,
                        pageSize: getPageSize(row),
                        sort: {
                            sortKey: 'rowNumber',
                            sortType: 'asc'
                        },
                        rowIdentifier: 'rowRepeater:' + row.id
                    };

                    rowHeight = rowRepeaterConfig.rowHeight;
                    rowListHeight = rowHeight * rowRepeater.rowList.length;
                    pagingHeight = rowRepeater.rowList.length > rowRepeater.pageSize ? pagingHeight : 0;
                    rowRepeater.rowHeight = titlebarHeight + rowListHeight + pagingHeight;

                    totalSectionHeight += rowRepeater.rowHeight;

                    rowList.push(rowRepeater);
                    rowRepeaterMap[rowRepeater.rowRepeaterId] = rowRepeater;
                }
                else {
                    fieldConfig = buildFieldStructureList(row.fields);

                    rowList.push({
                        rootFormId: rootFormId,
                        rowStructureId: rootFormId + '-' + row.id,
                        parentFormStructure: formRoot,
                        parentUiFormTemplate: formRoot.uiFormTemplate,
                        parentForm: formRoot.formModel,
                        rowTemplate: row,
                        fieldStructureList: fieldConfig.fieldStructureList,
                        rowHeight: fieldConfig.rowHeight,
                        rowIdentifier: 'fields:' + row.id
                    });

                    totalSectionHeight += fieldConfig.rowHeight;
                }
            });

            return {
                rowList: rowList,
                sectionHeight: totalSectionHeight
            };
        }

        function buildStaticRepeatingRowList(row) {

            let repeatingRowList = [],
                fieldConfig = buildFieldStructureList(row.fields, row, {rowNumber: 0}),
                maximumFieldHeight = fieldConfig.rowHeight;

            _.each(fieldConfig.fieldStructureList, function (fieldStructure) {
                fieldStructure.hideLabel = true;
            });

            repeatingRowList.push({
                parentForm: formRoot.formModel,
                parentFormStructure: formRoot,
                rootFormId: rootFormId,
                rowTemplate: row,
                rowModel: {rowNumber: 0},
                fieldStructureList: fieldConfig.fieldStructureList
            });

            return {
                rowHeight: maximumFieldHeight,
                repeatingRowList: repeatingRowList
            };
        }

        function buildRepeatingRowList(row) {
            let filteredRowInstanceList = _.filter(formRowInstanceList, {uiRowId: row.id}),
                repeatingRowList = [],
                fieldConfig,
                maximumFieldHeight = 100;

            _.each(filteredRowInstanceList, function (rowInstance) {

                fieldConfig = buildFieldStructureList(row.fields, row, rowInstance);
                maximumFieldHeight = fieldConfig.rowHeight;

                repeatingRowList.push({
                    parentForm: formRoot.formModel,
                    parentFormStructure: formRoot,
                    rootFormId: rootFormId,
                    rowTemplate: row,
                    rowModel: rowInstance,
                    fieldStructureList: fieldConfig.fieldStructureList
                });
            });
            if (repeatingRowList.length === 0) {
                fieldConfig = buildFieldStructureList(row.fields, row, {rowNumber: 0});
                maximumFieldHeight = fieldConfig.rowHeight;
                repeatingRowList.push({
                    parentForm: formRoot.formModel,
                    parentFormStructure: formRoot,
                    rootFormId: rootFormId,
                    rowTemplate: row,
                    rowModel: {rowNumber: 0},
                    fieldStructureList: fieldConfig.fieldStructureList
                });
            }

            return {
                rowHeight: maximumFieldHeight,
                repeatingRowList: repeatingRowList
            };
        }

        function buildFieldStructureList(rowFields, rowTemplate, rowModel) {
            let fieldStructureList = [],
                fieldStructure,
                isRowRepeater = rowModel && rowTemplate,
                maxFieldHeight = 32;

            _.each(rowFields, function (uiField) {
                let fieldModel;

                if (isRowRepeater) {
                    fieldModel = _.find(fieldInstanceList, function (instance) {
                        let isFieldMatch = instance.fieldTemplateId === uiField.fieldTemplate.id,
                            isInstanceMatch = instance.rowId === rowModel.id;

                        return isFieldMatch && isInstanceMatch;
                    });
                }
                else {
                    fieldModel = _.find(fieldInstanceList, {fieldTemplateId: uiField.fieldTemplate.id});
                }

                fieldStructure = {
                    fieldStructureId: rootFormId + '-' + uiField.fieldTemplate.id,
                    rootFormId: rootFormId,
                    parentForm: formRoot.formModel,
                    parentFormStructure: formRoot,
                    parentUiFormTemplate: formRoot.uiFormTemplate,
                    uiField: uiField,
                    fieldModel: fieldModel,
                    hasResponsiveLayout: formRoot.hasResponsiveLayout,
                    indexedName: formComponentUtil.getIndexedFieldName(uiField, isRowRepeater, rowModel),
                    originalVariableName: uiField.fieldTemplate.variableName,
                    isConfigurableComponent: formRoot.isConfigurableForm
                };

                if (isRowRepeater) {
                    fieldStructure.isRowRepeaterField = true;
                    fieldStructure.fieldStructureId += '-' + rowModel.id;
                    fieldStructure.rowNumber = rowModel.rowNumber;
                    fieldStructure.rowInstanceId = rowModel.id;
                    fieldStructure.rowRepeaterId = rowTemplate.id;
                    fieldStructure.rowRepeaterName = rowRepeaterUtil.getRowRepeaterName(rowTemplate.repeaterField);
                    fieldStructure.rowRepeaterModel = rowModel;
                    fieldStructure.rowRepeaterTemplate = rowTemplate;
                }

                formComponentUtil.setupFieldProperties(fieldStructure, currencyCode);

                fieldStructureList.push(fieldStructure);

                if (previousFieldKey) {
                    fieldMap.putAfter(previousFieldKey, fieldStructure.fieldStructureId, fieldStructure);
                    previousFieldKey = fieldStructure.fieldStructureId;
                } else {
                    fieldMap.put(fieldStructure.fieldStructureId, fieldStructure);
                }

                if (fieldStructure.layout.height > maxFieldHeight) {
                    maxFieldHeight = fieldStructure.layout.height;
                }
            });

            return {
                rowHeight: maxFieldHeight,
                fieldStructureList: fieldStructureList
            };
        }

        formConfig = buildSections(sourceForm.sections);
        formRoot.formName = formatUtil.formatAsSelector(formRoot.formModel.formTemplateUniqueName);
        formRoot.sectionList = formConfig.sectionList;
        formRoot.formHeight = formConfig.formHeight;
        formRoot.rowIdentifier = 'form:' + formRoot.formModel.id;

        $timeout(function () {
            defer.resolve(formRoot);
        }, 1, false);

        return defer.promise;
    };

    this.createField = function (formViewerInstance, rootFormId, dropConfiguration, skipFieldInsertion) {
        let isRowRepeater = false,
            currencyCode = null,
            uiField = dropConfiguration.uiField,
            newFieldId = uuidUtil.generateUUID(),
            newFieldStructure,
            firstAvailableRowInForm;

        function getFirstRowInForm(sectionList) {
            let result = null;

            _.each(sectionList, function (section) {

                if (result) {
                    return false;
                } else {
                    _.each(section.rowList, function (row) {
                        if (row.repeating) {
                            result = row.rowList[0];
                        } else {
                            result = row;
                        }
                        return false;
                    });
                }
            });

            return result;
        }

        firstAvailableRowInForm = getFirstRowInForm(formViewerInstance.formStructure.sectionList);

        newFieldStructure = {
            fieldStructureId: rootFormId + '-' + newFieldId,
            rootFormId: rootFormId,
            parentForm: formViewerInstance.formStructure.formModel,
            parentFormStructure: formViewerInstance.formStructure,
            parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate,
            uiField: uiField,
            fieldModel: null,
            hasResponsiveLayout: formViewerInstance.formStructure.hasResponsiveLayout,
            indexedName: formComponentUtil.getIndexedFieldName(uiField, isRowRepeater, null),
            originalVariableName: uiField.fieldTemplate.variableName,
            isConfigurableComponent: true,
            hideLabel: uiField.hideLabel
        };

        formComponentUtil.setupFieldProperties(newFieldStructure, currencyCode);

        if (!skipFieldInsertion) {
            firstAvailableRowInForm.fieldStructureList.push(newFieldStructure);
        }

        formViewerInstance.fieldMap.put(newFieldStructure.fieldStructureId, newFieldStructure);

        return newFieldStructure;
    };

    this.createSection = function (formViewerInstance, rootFormId, dropConfiguration) {
        let uiSection = dropConfiguration.uiSection,
            newSectionStructure,
            uiRow = uiSection.rows[0],
            newSectionId = uuidUtil.generateUUID(),
            newRowId = uuidUtil.generateUUID(),
            labelUiField = uiRow.fields[0],
            skipFieldInsertion = true,
            labelFieldStructure = this.createField(formViewerInstance, rootFormId, {uiField: labelUiField}, skipFieldInsertion);


        uiSection.uiFormTemplateId = parseInt(rootFormId);

        newSectionStructure = {
            rootFormId: rootFormId,
            sectionStructureId: rootFormId + '-' + newSectionId,
            sectionTemplate: uiSection,
            rowList: [{
                rootFormId: rootFormId,
                parentFormStructure: formViewerInstance.formStructure,
                parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate,
                parentForm: formViewerInstance.formStructure.formModel,
                rowTemplate: uiRow,
                fieldStructureList: [labelFieldStructure],
                rowHeight: 100,
                rowIdentifier: 'uiRow:' + newRowId
            }],
            sectionHeight: 100,
            parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate
        };

        formViewerInstance.formStructure.sectionList.unshift(newSectionStructure);

        return newSectionStructure;
    };

    this.getRowRepeaterField = function (rowList) {
        let result = null,
            fieldStructureList = _.last(rowList).fieldStructureList;

        _.each(fieldStructureList, function (fieldStructure) {
            let fieldStructureType = _.get(fieldStructure, 'uiField.fieldTemplate.type'),
                isRowRepeater = fieldStructureType === fieldType.ROWREPEATER;

            if (isRowRepeater) {
                result = fieldStructure;
                return false;
            }
        });

        return result;
    };

    this.createRowRepeater = function (formViewerInstance, rootFormId, dropConfiguration) {
        let uiRow = dropConfiguration.uiRow,
            skipFieldInsertion = true,
            rowStructure,
            rowList,
            newRowId = uuidUtil.generateUUID();

        function createFieldStructureList() {
            let fieldStructureList = [];

            _.each(uiRow.fields, (uiField) => {
                const fieldStructure = this.createField(formViewerInstance, rootFormId, {uiField: uiField}, skipFieldInsertion);
                fieldStructureList.push(fieldStructure);
            });

            return fieldStructureList;
        }

        rowList = [{
            parentForm: formViewerInstance.formStructure.formModel,
            parentFormStructure: formViewerInstance.formStructure,
            rootFormId: rootFormId,
            rowTemplate: uiRow,
            rowModel: {rowNumber: 0},
            fieldStructureList: createFieldStructureList.call(this)
        }];

        rowStructure = {
            rootFormId: rootFormId,
            rowStructureId: rootFormId + '-' + newRowId,
            parentFormStructure: formViewerInstance.formStructure,
            parentUiFormTemplate: formViewerInstance.formStructure.uiFormTemplate,
            parentForm: formViewerInstance.formStructure.formModel,
            rowRepeaterId: uiRow.id,
            rowRepeaterName: 'newRowRepeater-' + newRowId,
            repeaterFieldStructure: this.getRowRepeaterField(rowList),
            rowTemplate: uiRow,
            pageSize: 1,
            repeating: true,
            configurable: true,
            sort: {
                sortKey: 'rowNumber',
                sortType: 'asc'
            },
            rowHeight: 100,
            rowIdentifier: 'uiRow:' + newRowId,
            rowList: rowList
        };

        formViewerInstance.rowRepeaterMap[rowStructure.rowRepeaterId] = rowStructure;
        formViewerInstance.formStructure.sectionList[0].rowList.unshift(rowStructure);

        return rowStructure;
    };
};

angular.module('umFormViewer')
    .service('formStructureUtil', FormStructureUtil);
